document.addEventListener("DOMContentLoaded", function() {
  const MAX_LENGTH = 30;

  // 商品一覧ページのみ対象（class名で判定）
  const targets = ['template-collection', 'template-search', 'index'];
  const isTargetPage = targets.some(cls => document.body.classList.contains(cls));
  if (!isTargetPage) return;

  const titles = document.querySelectorAll('.card__heading a.full-unstyled-link');
  titles.forEach(title => {
    const fullText = title.textContent.trim();
    if (fullText.length > MAX_LENGTH) {
      title.textContent = fullText.slice(0, MAX_LENGTH) + '...';
    }
  });
});
